import ContentfulImage from '@/components/contentful-image';
import { ArticleFeaturedProps } from '@/lib/interface-types';
import Link from 'next/link';
import RichText from '../rich-text';

const ArticleLanding = (props: ArticleFeaturedProps) => {
  const { article, subCategory } = props;

  const generateArticleUrl = (article: {
    category?: string;
    slug: string;
    subCategory?: string;
  }) => {
    if (!article.category) return `/${article.slug}`;

    if (article.subCategory && article.subCategory !== subCategory) {
      return `/${article.category.toLowerCase().replace('incyber-', '')}/${
        article.subCategory
      }/${article.slug}`;
    }
    return `/${article.category.toLowerCase().replace('incyber-', '')}/${
      article.slug
    }`;
  };

  const articleUrl = generateArticleUrl(article);

  return (
    <article className="ArticleLanding col-span-1 flex secondary-color mb-4">
      <Link href={articleUrl} className="flex">
        <div className="relative flex-initial w-[100px] h-[100px] overflow-hidden">
          {article?.featuredImage?.url && (
            <ContentfulImage
              alt={article?.featuredImage?.title}
              className="object-cover w-[80px] h-full"
              src={article?.featuredImage?.url}
              fill
              sizes="99.99vw"
            />
          )}
        </div>

        <header className="w-[170px] ml-4">
          {article?.featuredTitle && (
            <h4 className="font-bold font-sans text-base uppercase mt-0 mb-1">
              {article?.featuredTitle}
            </h4>
          )}

          {article.featuredDescription && (
            <RichText data={article?.featuredDescription} />
          )}
        </header>
      </Link>
    </article>
  );
};

export default ArticleLanding;
